import { PageHero } from '@/components/PageHero';
import { Reveal } from '@/components/fx/Reveal';
import type { FaqVals } from '@/lib/vals/faq';

export function FaqPage({ v }: { v: FaqVals }) {
  return (
    <main id="wft-main" tabIndex={-1}>
      <PageHero
        eyebrow="FAQ"
        title="Questions with answers in the repository."
        highlight={['repository.']}
        lede="Nothing here is aspirational. Where something is not built, the answer says so and names the module."
      />

      <section className="section section--tight">
        <div className="shell">
          <ul className="faq" aria-label="Questions">
            {v.faq.map((item, i) => (
              <Reveal as="li" key={item.q} delay={Math.min(i, 8) * 45} className="faq__item">
                <button
                  type="button"
                  className={`faq__q ${item.open ? 'is-open' : ''}`}
                  aria-expanded={item.openStr}
                  onClick={item.toggle}
                >
                  <span className="faq__tag">{item.tag}</span>
                  <span className="faq__text">{item.q}</span>
                  <span className="faq__marker" aria-hidden="true">
                    <i />
                    <i />
                  </span>
                </button>
                {/* Height animates via a grid row rather than max-height, so the
                    transition matches the real content height at any width.
                    `inert` when closed keeps the answer in the DOM for crawlers
                    while taking it out of the accessibility tree and the tab
                    order — CSS visibility alone would not stop focus. */}
                <div
                  className={`faq__panel ${item.open ? 'is-open' : ''}`}
                  {...(item.open ? {} : { inert: '' })}
                >
                  <div className="faq__panelInner">
                    <p>{item.a}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
}
